<template>
  <OppleAuth code="ReadArea,ControlArea" :force-show="noAuth || $store.state.isPassPermission">
    <div class="scence_box clearfix scence_box_action">
      <!-- 国内需要校验 --->
      <div v-if="noAuthControl" class="areacotrol_masker" />
      <div
        v-for="(tem, index) in renderList"
        :key="index"
        class="device_div_action"
        :class="{'device_div_collapse': tem.Values[0].ValueType === 'UIControl_Scene_Baoli'}"
      >
        <div class="">
          <!--统一控制 8 设备操作-->
          <control-item
            :checkeddata="checkeddata"
            :show-button="isdevice"
            :action-info="tem"
            :show-check-box="showCheckBox"
            :is-i-f-t-t="isIFTT"
            :action-list="renderList"
            @changeCheckBox="checkRadioAction(tem)"
            @button-action="doIsjoined"
            @do-call-action-middle="doChange"
          />
        </div>
      </div>
      <slot />
    </div>
  </OppleAuth>
</template>

<script>
import {
  OpenLight,
  CloseLight,
  AdjustBright,
  AdjustTemperature,
  AdjustColor,
  StepDimming,
  StepCCT,
  LightMode,
  GetCallScene
} from '@/axios/IArea.js'
import {IsExistAreaAndAddressMap} from '@/axios/IDevice.js'
import { alerterror, alertsuccess } from '@/assets/js/common.js'
import ControlItem from '@/components/common/controlItem'
import { getFillOrderFn } from '@/page/control-ts/scene/sceneHandle/indexFns'
import { transLightToValue } from '@/utils/actionsHandler';
import {GetThirdPartSceneList} from '@/axios/IDevice.js'
import { isExistPermission } from '@/components/OppleAuth/index';
import { ActionVo } from '@/utils/actionsHandler'

let getSortOrderValue = () => null
let minValue 
let minColorWarm
let maxColorWarm
const getList = ($t, isdevice) => [
  {
    isCollapse: true,
    ischeck: !isdevice,
    Desc: $t('sceneCard.colorWarm'),
    MsgType: '0x04',
    orderType: '0x031B0000',
    Values: [{
      KeyId: 1,
      IsShow: true,
      ValueType: 'UIControl_ColorTemperature',
      Min: minColorWarm,
      Max: maxColorWarm,
      isChange: false,
      DefaultValue: 4000,
      Type: '0x04',
      Name:$t('sceneCard.colorWarm'),
    }]
  },
  {
    isCollapse: true,
    ischeck: !isdevice,
    ChannelId: 0,
    CnDesc: null,
    Desc: $t('sceneCard.color'),
    MsgType: ['0x05', '0x18'],
    orderType: '',
    Reserve: '0x00000000',
    Selected: false,
    ShowMode: -1,
    UI: null,
    Values: [{
      IsShow: true,
      KeyId: 1,
      ValueType: 'UIControl_ColorPanel',
      DefaultValue: '0',
      Name:$t('sceneCard.color'),
    }]
  },
  {
    isCollapse: true,
    ischeck: !isdevice,
    Desc: $t('sceneCard.light'),
    MsgType: '0x03',
    orderType: '0x03130000',
    Values: [{
      IsShow: true,
      KeyId: 1,
      ValueType: 'UIControl_Bright',
      Min: minValue,
      Max: 100,
      isChange: false,
      DefaultValue: 100,
      Type: '0x03',
      Name:$t('sceneCard.light'),
    }],
  },
  {
    isCollapse: true,
    ischeck: !isdevice,
    Desc: $t('sceneCard.dim'),
    MsgType: '0x03DA00000x03840000',
    orderType: '0x03840000',
    Values: [{
      IsShow: true,
      KeyId: 1,
      ValueType: 'UIControl_UpAndDown',
      DefaultValue: 0,
      EnumValue: [
        { Name: $t('sceneCard.dimmingDown'), Value: 1 }, { Name: $t('sceneCard.dimmingUp'), Value: 0 }
      ],
      Name:$t('sceneCard.dim'),
    }]
  },
  {
    isCollapse: true,
    ischeck: !isdevice,
    ChannelId: 0,
    CnDesc: null,
    Desc: $t('sceneCard.cct'),
    MsgType: '0x03880000',
    orderType: '0x03880000',
    Values: [{
      IsShow: true,
      KeyId: 1,
      ValueType: 'UIControl_UpAndDown',
      DefaultValue: 0,
      EnumValue: [
        { Name: $t('sceneCard.cctWarm'), Value: 1 }, { Name: $t('sceneCard.cctCold'), Value: 0 }
      ],
      Name:$t('sceneCard.cct'),
    }]
  }
]
export default {
  components: {
    ControlItem,
  },
  props: {
    highid: {
      type: Number,
      default: -1
    },
    isdevice: {
      type: Boolean,
      default: false
    },
    checkeddata: {
      type: Array,
      default () {
        return []
      }
    },
    noAuth: {
      type: Boolean,
      default: false
    },
    //是否过滤颜色
    fliterColor:{
      type: Boolean,
      default: false
    },
    isExistGsDevice: {
      type: Boolean,
      default: false
    },
     areaControlType: {
      type: String,
      default: 'IFttt',
    },
    showCheckBox: {
      type: Boolean,
      default: false,
    },
    isIFTT: {
      type: Boolean,
      default: false,
    },
    propsList: {
      type: Array,
      default: () => [],
    },
    tempareaactionPannel: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      noAuthControl: false,
      list: [],
      color: 'rgb(0, 0, 0)', // 颜色
      doChangeTime: null, // 延时下发规避频繁
      switchDefaultValue: 0,
      isShowSceneGroup: false,
      oppleSwitch:[
        { 
          isCollapse: true,
          ischeck: !this.isdevice,
          Desc: this.$t('sceneCard.lightSwitch'),
          MsgType: '0x02',
          orderType: '0x03110000',
          Values: [{
            KeyId: 1,
            IsShow: true,
            ValueType: 'UIControl_Switch',
            DefaultValue: 0,
            Name: this.$t('sceneCard.lightSwitch'),
          }]
        },
      ],
      baoLiSwitch:[
        {
          isCollapse: true,
          ischeck: !this.isdevice,
          Desc: this.$t('sceneCard.workStatus'),
          MsgType: '0x06',
          orderType: '0x03110000',
          Values: [{
            KeyId: 1,
            IsShow: true,
            ValueType: 'UIControl_Radio_Baoli',
            DefaultValue: 0,
            EnumValue:[
            { Name: this.$t('sceneCard.sensor'), Value: 0 },
            { Name: this.$t('sceneCard.alwaysOpen'), Value: 1 },
            { Name: this.$t('sceneCard.alwaysClose'), Value: 2 },
            { Name: this.$t('sceneCard.sleep'), Value: 3 },
            ],
            Name:this.$t('sceneCard.workStatus'),
          }]
        },
        {
          isCollapse: true,
          ischeck: !this.isdevice,
          ChannelId: 0,
          CnDesc: null,
          Desc: this.$t('sceneCard.sceneNumber'),
          MsgType: '0x05880000',
          orderType: '0x05880000',
          Values: [{
            IsShow: true,
            KeyId: 1,
            ValueType: 'UIControl_Scene_Baoli',
            DefaultValue: 0,
            EnumValue:[],
            Name:this.$t('sceneCard.sceneNumber'),
          }]
        }
      ]
    }
  },
  computed: {
    appDocumentWidth () {
      return this.$store.state.appDocumentWidth
    },
    renderList() {
      if (this.areaControlType === 'IFttt') {
        this.handleAction(this.propsList)
        return this.propsList
      } else {
        this.handleAction(this.list)
        return this.list
      }
    },
  },
  watch: {
    appDocumentWidth (value, oldVal) {
      console.log(`appDocumentWidth`,value, oldVal)
      if (oldVal === value || !this.isdevice) return
      getSortOrderValue = getFillOrderFn(value)
      this.fillList()
    }
  },
  mounted () {
    getSortOrderValue = getFillOrderFn(this.appDocumentWidth)
    console.log('getSortOrderValue', getSortOrderValue)
    this.fillList()

    if (this.noAuth) return;

    this.noAuthControl = !isExistPermission('ControlArea', this.$store.state.isPassPermission);
  },
  methods: {
    canEdit(item, mode) {
      console.log('this.tempareaactionPannel', this.tempareaactionPannel)
      if(this.tempareaactionPannel) return true
      let resultItem = this.propsList.find(model => model.Values[0].ValueType === 'UIControl_Switch');
      if(!resultItem) return true
      let result = resultItem && resultItem.Values[0].DefaultValue;
      if(mode.Type === "0x0207") {
        result = true;
      } else if(!result && !this.tempareaactionPannel) {
        this.propsList.find(el => {
          const isSame = el.Values[0].Type === mode.Type;
          if (isSame) {
            el.ischeck = false;
          }
          return isSame
        })
      }
      return result
    },
     //处理下能力
    handleAction(list) {
      list.forEach(model => {
        //model.ischeck = true
        if (model.Values[0].ValueType === 'UIControl_Bright') {
          model.Values[0].Max = 100
        }
      })
    },
    checkRadioAction(item) {
      
      const {
        result,
        passMsg
      } = ActionVo.isConflictAction('IFTTT', item.MsgType, this.renderList.filter(item => !!item.ischeck));

      if (item.ischeck === false && !result) {
        this.$message.warning(passMsg);

        return;
      };
      
      item.ischeck = !item.ischeck
    },
    async addSceneOnList() {
      let tempArr = []
      if (this.isExistGsDevice) {
        try {
          const {StatusCode,Result} = await GetThirdPartSceneList({ BrandId: 1024 })
          if (StatusCode == this.$store.state.rightStatusCode) {
            tempArr = getList(this.$t, this.isdevice).concat(this.baoLiSwitch)

            tempArr = tempArr.map(item => {
              if (item.Values[0].ValueType == 'UIControl_Scene_Baoli') {
                return {
                  ...item,
                  Values:[{ ...item.Values[0], EnumValue: Result || [] }]
                };
              }
              return item;
            });
          }
          this.list = tempArr.map(el => { el.orderId = getSortOrderValue(el.orderType, !this.isdevice) || 1; return el }).sort((el, next) => next.orderId - el.orderId)
        } catch (error) {
          console.log(error);
        }
      } else {
        tempArr = getList(this.$t, this.isdevice).concat(this.oppleSwitch)
        this.list = tempArr.map(el => { el.orderId = getSortOrderValue(el.orderType, !this.isdevice) || 1; return el }).sort((el, next) => next.orderId - el.orderId)
      }

      if(this.fliterColor){
        this.list = this.list.filter((item)=>item.Desc !== this.$t('sceneCard.color'))
      }
      console.log('....addSceneOnList',this.list)
    },
    fillList () {
      try {
        /* 为了解决SDL色温范围欧洲保持2700-6500 */
        let areaControlWarn = this.$store.state.staticConfig.AreaControl.ColorWarn
        let Version = this.$store.state.areaControlConfig ? 'CN' : "EU"
        areaControlWarn = areaControlWarn.filter(item =>  item.DataCenter.indexOf(Version) !== -1 )
        minColorWarm = this.$store.state.colorTemperatureRange.Min; // areaControlWarn[0].Min
        maxColorWarm = this.$store.state.colorTemperatureRange.Max; // areaControlWarn[0].Max
      } catch (error) {
        minColorWarm = this.$store.state.colorTemperatureRange.Min; // this.$store.state.areaControlConfig ? 1800 : 2700
        maxColorWarm = this.$store.state.colorTemperatureRange.Max; // this.$store.state.areaControlConfig ? 12000 : 6500
      }
      minValue = this.$store.state.staticConfig.AbilityConfig.DefaultValue.GeneralControl['0x03130000'].Value.minValue
      // this.list = getList(this.$t, this.isdevice).map(el => { el.orderId = getSortOrderValue(el.orderType, !this.isdevice) || 1; return el }).sort((el, next) => next.orderId - el.orderId)
      // this.list = getList(this.$t, this.isdevice).map(el => { el.orderId = getSortOrderValue(el.orderType, !this.isdevice) || 1; return el }).sort((el, next) => next.orderId - el.orderId)
      this.addSceneOnList()//保利项目增加感应模式和情景号
    },
    /* 选取颜色
    */
    doAdjustColor (_index) {
      if (_index) {
        let arry = _index.slice(4, -1).split(',')
        let para = { gpNo: this.highid, r: arry[0], g: arry[1], b: arry[2] }
        AdjustColor(para, this.functionDoNotice)
        para = null
        arry = null
      }
    },
    /**
     * 步长
     * 0-dimming up 1-dimming down
     */
    buttonClickDim (index) {
      StepDimming({ gpNo: this.highid, value: index }, this.functionDoNotice)
    },

    /**
     * 步长
     * 0-color cold 1-color warm
     */
    buttonClickCCT (index) {
      StepCCT({ gpNo: this.highid, direction: index }, this.functionDoNotice)
    },

    /* 点击灯开关
    */
    buttonClick (index) {
      if (index == 1) {
        // 关灯
        this.doOpenLight()
      } else {
        this.doCloseLight()
      }
      this.actiove = index
    },
    /* 关闭灯
    */
    doCloseLight () {
      let para = { gpNo: this.highid }
      CloseLight(para, this.functionDoNotice)
      para = null
    },
    /* 打开灯
    */
    doOpenLight () {
      let para = { gpNo: this.highid }
      OpenLight(para, this.functionDoNotice)
      para = null
    },
    /* 统一控制参与方法 根据type来区分
    * _type 类型
    * _index 序号
    */
    doIsjoined (item) {
      
      let _type = item.MsgType
      const _index = item.ischeck
      
      if (this.isdevice) {
        if (_type == '0x03DA00000x03840000') {
          _type = ['0x03D80000', '0x03DA0000', '0x03840000']
        } else if (_type == '0x03880000') {
          _type = ['0x03880000']
        }
        this.$emit('Isjoined', [_type, _index])
      }
    },
    /* 统一控制处理方法 根据type来区分
    * _type 类型
    * _index 序号
    */
    doChange (item, deviceInfo, _index, isColor) {
     if (this.areaControlType === 'IFttt') return
      console.log('doChange', item, deviceInfo, _index, isColor)
      /* start 避免控制台打开后就触发操作 */
      // const value_ = item.Values[0]
      // if (typeof value_.isChange === 'boolean') {
      //   if (!value_.isChange) {
      //     value_.isChange = true
      //     return
      //   }
      // }
      /* end */
      const _type = item.MsgType
      if (this.doChangeTime != null) {
        clearTimeout(this.doChangeTime)
      }
      this.doChangeTime = setTimeout(this.doChangeIn, 500, _type, _index, isColor)

    },
    /* 统一控制处理方法 根据type来区分
    * _type 类型
    * _index 序号
    */
    doChangeIn (_type, _index, isColor) {
      
      if (this.isdevice) {
        if (isColor && _index.indexOf('rgb') != -1) {
          _index = _index.colorHex()
        }
        this.$emit('Issued', [_type, _index])
      } else if (_type == '0x04') {
        this.doAdjustTemperature(_index)
      } else if (_type == '0x03') {
        this.doAdjustBright(_index)
      } else if (_type == '0x02') {
        this.buttonClick(_index)
      } else if (_type.indexOf('0x02') != -1 || _type.indexOf('0x18') != -1) {
        this.doAdjustColor(_index)
      } else if (_type == '0x03DA00000x03840000') {
        // 分级调光
        this.buttonClickDim(_index)
      } else if (_type == '0x03880000') {
        // 分级调色温
        this.buttonClickCCT(_index)
      }else if(_type == '0x06'){
        //保利开关 感应模式
        this.doAdjustSenceMode(_index)
      }else if(_type == '0x05880000'){
        //情景号
        this.checkAreaMap(_index)
      }
    },
    /* 统一控制 接口数据返回方法
    * rs 接口返回数据包
    */
    functionDoNotice (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 调节亮度
    */
    doAdjustBright (_index) {
      // 调节亮度
      let para = { gpNo: this.highid, bright: transLightToValue(_index, 255) }
      AdjustBright(para, this.functionDoNotice)
      para = null
    },
    /* 调节色温
    */
    doAdjustTemperature (_index) {
      // 调节色温
      let para = { gpNo: this.highid, temperature: _index }
      AdjustTemperature(para, this.functionDoNotice)
      para = null
    },
    /**
     * 调节感应模式
     */
    doAdjustSenceMode (_index) {
      let para = { gpNo: this.highid, mode: _index }
      LightMode(para, this.functionDoNotice)
      para = null
    },
    async checkAreaMap(index){
      try{
        const res = await IsExistAreaAndAddressMap({gpNo: this.highid})
        if (res.StatusCode == this.$store.state.rightStatusCode) {
          if(res.Result){
            const sceneRes = await GetCallScene({gpNo: this.highid,SceneId:index})
            if(sceneRes.StatusCode == this.$store.state.rightStatusCode){
              alertsuccess(this, sceneRes.StatusCode)
            }
          }else{
            this.$emit('showAreaMapTiop', !res.Result)
          }
        }
      }catch(error){
        console.error('An error occurred in checkAreaMap:', error)
      }
    },
  }
}
</script>

<style scoped="scoped" lang="scss">
@import "~@/assets/css/action.scss";
.scenceMsg {
  .sevice_slider {
    width: calc(100% - 270px) !important;
  }

  .joinTool {
    /*width: 120px;*/
    margin: 0;
    display: inline-block;
  }
}
.scence_box {
  position: relative;
  margin-top: 10px;
}
.all_set .scence_box .device_div_collapse{
  width: 100% !important;
}
.box_reset_size{
  height: 44vh;
}
.box_reset_size .device_div .scence_ctr {
  height: 20px;
  line-height: 20px;
}
.areacotrol_masker {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 999999999;
}
</style>
